import { useEffect, useState } from 'react';
import React from 'react';

import { Spin, Table, message } from 'antd';

import sessionManager, { eVariableType } from '../../SessionManager';
import { GetFormattedData } from '../../Utility';
import api from '../../api';
import stringres from '../../translations/stringres';

export default function ClienteDocumentiRighe(props) {
    const { codCliente } = props;

    const { tipoDocumento } = props;
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        async function fetchData() {
            try {
                setIsLoading(true);

                const result = await api.get(
                    'Documenti/RigheMateriale?idSocieta=' +
                        sessionManager.get(eVariableType.IDSocieta) +
                        '&codCliente=' +
                        codCliente +
                        '&tipoDocumento=' +
                        tipoDocumento
                );

                if (result != null && result.data != null) setData(result.data);
            } catch (error) {
                message.error(error.message);
            } finally {
                setIsLoading(false);
            }
        }

        fetchData();
    }, []);

    const columns = [
        { title: stringres.t('numeroDocumento'), dataIndex: 'numeroDocumento', width: 100 },
        { title: stringres.t('gruppoDocumento'), dataIndex: 'gruppoDocumento', width: 60 },
        {
            title: stringres.t('dataDocumento'),
            dataIndex: 'dataDocumento',
            width: 125,
            render: (text) => (
                <span>
                    <GetFormattedData data={text}></GetFormattedData>
                </span>
            ),
        },
        { title: stringres.t('qualita'), dataIndex: 'qualita' },
        { title: stringres.t('finitura'), dataIndex: 'finitura' },
        { title: stringres.t('qta'), dataIndex: 'qta', width: 100 },
        { title: stringres.t('um'), dataIndex: 'um', width: 75 },
        { title: stringres.t('pezzi'), dataIndex: 'pezzi', width: 100 },
        { title: stringres.t('importo'), dataIndex: 'importo', width: 100 },
        { title: stringres.t('codValuta'), dataIndex: 'codValuta', width: 100 },
    ];

    const rowKeys = ['numeroDocumento', 'qualita', 'finitura', 'importo'];

    return (
        <Spin spinning={isLoading}>
            <Table
                rowKey={(row) => rowKeys.map((key) => row[key]).join('-')}
                columns={columns}
                dataSource={data}
            ></Table>
        </Spin>
    );
}
